import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Tabs,
  TabsList,
  TabsTrigger,
} from '@ais-ui/ui-core';

import React, { useCallback, useState } from 'react';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { ReceivedMessages } from './ReceivedMessages';
import { MessageSchedules } from './MessageSchedules';
import { SentMessages } from './SentMessages';

interface MessagesProps {
  className: string;
}

export const Messages = React.memo(({ className }: MessagesProps) => {
  const { messages } = useLocalization();
  const onExit = useOnMapPanelExit();
  const [tab, setTab] = useState<'received' | 'sent' | 'scheduled'>('received');

  const handleTabChange = useCallback((value: string) => {
    setTab(value as 'received' | 'sent' | 'scheduled');
  }, []);

  return (
    <Card className={cn('flex flex-col', className)}>
      <CardHeader>
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <CardTitle className="text-lg font-medium text-muted-foreground">
              {messages.messagesTitle}
            </CardTitle>
            <Button
              variant="ghost"
              size="icon"
              className="-mt-8 -mr-4"
              onClick={onExit}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
                className="h-4 w-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </Button>
          </div>
          <Tabs
            value={tab}
            onValueChange={handleTabChange}
            className="w-full space-y-6 pt-4 h-full flex flex-col"
          >
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger id="received-tab-button" value="received">
                Received
              </TabsTrigger>
              <TabsTrigger id="sent-tab-button" value="sent">
                Sent
              </TabsTrigger>
              <TabsTrigger id="scheduled-tab-button" value="scheduled">
                Scheduled
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </CardHeader>
      {tab === 'received' && <ReceivedMessages />}
      {tab === 'sent' && <SentMessages />}
      {tab === 'scheduled' && <MessageSchedules />}
    </Card>
  );
});

Messages.displayName = 'Messages';
